import {
  getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject


} from "firebase/storage";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase"; // ensure firebase config exports db
import Cookies from "js-cookie"; // ✅ missing import
import { Randomcode } from "../components_root/rendom_code";
export const Product_uploader_files = async (data) => {
  const { file, tablename, fileuid, filename, fileslimit } = data || {};


  if (!fileuid?.trim()) {
    return { success: false, error: "Missing fileUID" };
  }
  if (!file) {
    return { success: false, error: "Missing file" };
  }

  if (!tablename?.trim()) {
    return { success: false, error: "Missing tablename" };
  }
  if (!filename?.trim()) {
    return { success: false, error: "Missing filename" };
  }

  // ✅ File validation
if (
  !(
    file.type.startsWith("image/") ||
    file.type === "video/mp4"
  )
) {
  return { success: false, error: "Only image and .mp4 video files are allowed!" };
}
  if (file.size > 1 * 1024 * 1024 && file.type != "video/mp4") {
    return { success: false, error: "File size must be under 1MB!" };
  }
 if (file.size > 2 * 1024 * 1024 && file.type === "video/mp4" ) {
    return { success: false, error: "File size must be under 2MB!" };
  }
 
  
  // ✅ Session validation
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");
  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!companyuid || companyuid === "undefined")
    return { success: false, error: "Please select company." };



  try {
    const productQuery = query(
      collection(db, "files"),
      where("companyuid", "==", companyuid),
      where("filename", "==", filename),
      where("fileuid", "==", fileuid)
    );
    const productSnap = await getDocs(productQuery);
    if (!productSnap.empty && productSnap.size >= fileslimit) {
      return {
        success: false,
        error: `This product "${filename}" is over the allowed limit of ${fileslimit}.`
      };
    }



    const storage = getStorage();
    const uid = Randomcode(22);
    const filename_url = `${uid}.${file.name.split('.').pop()}`;
    const storageRef = ref(storage, `uploadsfiles/${filename_url}`);




    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // progress percent (can be lifted into a callback if needed)
          const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload progress: ${Math.round(percent)}%`);
        },
        (err) => {
          console.error("Upload failed:", err);
          reject({ success: false, error: err.message || err.code || err });
        },
        async () => {
          try {
            // ✅ Upload complete → get file URL
            const url = await getDownloadURL(uploadTask.snapshot.ref);

            // ✅ Save to Firestore
            const parentDocRef = doc(db, "files", uid);
            const savequery = {
              uid: uid,
              companyuid,
              tablename: tablename,
              fileuid: fileuid,
              filename: filename,
              url: url,
              size: file.size,
              type: file.type,
              guid: guid,
              sessiontoken: sessiontoken,
              date_time: new Date(),
            };
            await setDoc(parentDocRef, savequery, { merge: true });

            //update main table
            // const updatefile = doc(db, tablename, fileuid);
            // const updatefilequery = {
            //   [filename + "_url"]: url,
            //   [filename + "_uid"]: uid,
            // };

            // await setDoc(updatefile, updatefilequery, { merge: true });
            //deleteFileByUid(old_file_uid);
            resolve({ success: true, fileurl: url });
          } catch (firestoreErr) {
            reject({ success: false, error: firestoreErr.message });
          }
        }
      );
    });



  } catch (err) {
    console.error("Upload failed:", err);
    return { success: false, error: err.message || err.code || err };
  }
};
